import type { ComponentProps } from "react";
import { cn } from "~/shared/lib";

type LabelInputProps = ComponentProps<"label"> & {
  required?: boolean;
};

export function LabelInput({
  htmlFor,
  children,
  required,
  ...props
}: LabelInputProps) {
  if (!children) {
    return null;
  }

  return (
    <label
      htmlFor={htmlFor}
      {...props}
      className={cn("cursor-pointer text-sm font-semibold", props.className)}
    >
      {children}
      {required && <span className="text-red-500 ltr:ml-1 rtl:mr-1">*</span>}
    </label>
  );
}
